const DESKTOP = matchMedia('(min-width: 990px)');

/**
 * <galaxy-footer-fold>: a footer link column that folds into a tap-to-open row below 990px
 * and is always open (not clickable) on desktop.
 */
class GalaxyFooterFold extends HTMLElement {
  #controller = new AbortController();

  get #details() {
    return this.querySelector('details');
  }

  connectedCallback() {
    const { signal } = this.#controller;
    this.#sync();
    DESKTOP.addEventListener('change', this.#sync, { signal });
    this.#details?.querySelector('summary')?.addEventListener(
      'click',
      (event) => {
        if (DESKTOP.matches) event.preventDefault();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #sync = () => {
    const details = this.#details;
    if (details) details.open = DESKTOP.matches;
  };
}

if (!customElements.get('galaxy-footer-fold')) {
  customElements.define('galaxy-footer-fold', GalaxyFooterFold);
}
